import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
// import logo from "../assests/Logo.png";
import { FiAlignRight, FiX } from "react-icons/fi";
import Fade from "react-reveal/Fade";
import { TfiEmail } from "react-icons/tfi";
import { GiHamburgerMenu } from "react-icons/gi";
import { AiOutlineClose } from "react-icons/ai";

export default function Navbar() {
  const [isShow, setIsShow] = useState(false);

  function hamburger() {
    setIsShow(!isShow);
    // window.alert("Hamburger is clicked");
  }

  const [isScrolling, setIsScrolling] = useState(false);
  const [isActive, setIsActive] = useState("home");
  const [toggleMenu, setToggleMenu] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 0) {
        setIsScrolling(true);
        setToggleMenu(false);
      } else if (window.scrollY === 0) {
        setIsScrolling(false);
      }
    });
  });
  //-------
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const sectionOffsets = {
        home: document.getElementById("home").offsetTop,
        about_me: document.getElementById("about_me").offsetTop,
        // about__Us: document.getElementById("about__Us").offsetTop,
        services: document.getElementById("services").offsetTop,
        projects: document.getElementById("projects").offsetTop,

        // consulting: document.getElementById("consulting").offsetTop,
        // contact__us: document.getElementById("contact__us").offsetTop,
      };
      let activeSection = "";

      Object.entries(sectionOffsets).forEach(([sectionId, offset]) => {
        if (scrollPosition >= offset - window.innerHeight / 3) {
          activeSection = sectionId;
        }
      });

      setIsActive(activeSection);
      setIsScrolling(scrollPosition > 0);

      setToggleMenu(false);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  function scrolldiv(scroll, offset) {
    var elem = document.getElementById(scroll);
    if (elem) {
      window.scrollTo({
        top: elem.offsetTop - offset,
        behavior: "smooth",
      });
    }
  }

  window.onload = function () {
    var isRefreshed =
      performance &&
      performance.navigation &&
      performance.navigation.type === performance.navigation.TYPE_RELOAD;

    if (isRefreshed) {
      scrolldiv("home", 0);
    } else {
      scrolldiv("home", 0);
      // setIsActive("home");
    }
  };

  const handleGetInTouch = () => {
    const getInTouchSection = document.getElementById("contact_us");
    if (getInTouchSection) {
      const topOffset = getInTouchSection.offsetTop;
      window.scrollTo({
        top: topOffset,
        behavior: "smooth",
      });
    }
  };

  return (
    <>
      <Fade top>
        <nav
          className={
            isScrolling
              ? "NavBar_Main_Container Active_Header"
              : "NavBar_Main_Container"
          }
          style={{ backgroundColor: isScrolling ? "white" : "#171717" }}
        >
          <div className="navbarInnerContainer">
            <div className="flex items-center justify-between w-full px-0">
              <div className="navbarLogoContainer">
                {/* <img
                className="cursor-pointer"
                src={logo}
                alt=""
                onClick={() => {
                  // setIsActive("home");
                  scrolldiv("home", 0);
                }}
              /> */}
                <h1
                  className={`text-lg sm:text-2xl tracking-wider cursor-pointer sm:ml-6 transition-colors duration-300 ${
                    isScrolling ? "text-black" : "text-white"
                  }`}
                  style={{ fontFamily: "'Playfair Display', serif" }}
                  onClick={() => scrolldiv("home", 0)}
                >
                  Zulqarnain Mahmood
                </h1>
              </div>

              <div className="Navlink_Wrapper">
                <NavLink
                  to="#home"
                  onClick={() => {
                    setIsActive("home");
                    scrolldiv("home", 0);
                  }}
                  className={
                    isActive === "home" ? "Link_Style_Scroll" : "Link_Style"
                  }
                  style={({ isActive }) => ({
                    backgroundColor: isScrolling ? "" : "#171717",
                    color: isScrolling ? "#171717" : "white",
                    border: "none",
                    borderRadius: "60px",
                  })}
                >
                  Home
                </NavLink>
                <NavLink
                  to="#about_me"
                  activeStyle={{
                    color: isActive === "about_me" ? "#EDD569" : "",
                  }}
                  className={
                    isActive === "about_me" ? "Link_Style_Scroll" : "Link_Style"
                  }
                  onClick={() => {
                    // setIsActive("logistics");
                    scrolldiv("about_me", 90); // Adjust the offset as per your requirement
                  }}
                  style={({ isActive }) => {
                    return {
                      backgroundColor: isScrolling ? "" : "#171717",
                      color: isScrolling ? "#171717" : "white",
                      border: "none",
                      borderRadius: "60px",
                    };
                  }}
                >
                  About Me
                </NavLink>
                {/* <NavLink
                  to="/document_verification"
                  activeStyle={{
                    color: isActive === "aboutUs" ? " #EDD569" : "",
                  }}
                  className={
                    isActive === "about__Us"
                      ? "Link_Style_Scroll"
                      : "Link_Style"
                  }
                  onClick={() => {
                    scrolldiv("about__Us", 90);
                  }}
                  style={({ isActive }) => {
                    return {
                      backgroundImage: isActive
                        ? "background-color: #EDD569"
                        : "",
                      color: isActive ? "white" : "white",
                      border: "none",
                      borderRadius: "60px",
                    };
                  }}
                >
                  About us
                </NavLink> */}
                <NavLink
                  to="/document_verification"
                  activeStyle={{
                    color:
                      isActive === "document_verification" ? " #EDD569" : "",
                  }}
                  className="Link_Style"
                  // className={
                  //   isActive === "about__Us"
                  //     ? "Link_Style_Scroll"
                  //     : "Link_Style"
                  // }
                  // onClick={() => {
                  //   setIsActive("about__Us");
                  //   scrolldiv("about__Us", 90);
                  // }}
                  style={({ isActive }) => {
                    return {
                      backgroundImage: isActive
                        ? "background-color: #EDD569"
                        : "",
                      color: isActive ? "white" : "white",
                      color: isScrolling ? "#171717" : "white",
                      border: "none",
                      borderRadius: "60px",
                    };
                  }}
                >
                  Document Verification
                </NavLink>

                <NavLink
                  to="#services"
                  activeStyle={{
                    color: isActive === "services" ? " #EDD569" : "",
                  }}
                  className={
                    isActive === "services" ? "Link_Style_Scroll" : "Link_Style"
                  }
                  onClick={() => {
                    // setIsActive("mission__vision");
                    scrolldiv("services", 90);
                  }}
                  style={({ isActive }) => {
                    return {
                      backgroundImage: isActive
                        ? "background-color: #EDD569"
                        : "",
                      color: isActive ? "white" : "#266A86",
                      color: isScrolling ? "#171717" : "white",
                      border: "none",
                      borderRadius: "60px",
                    };
                  }}
                >
                  Services
                </NavLink>

                <NavLink
                  to="#projects"
                  activeStyle={{
                    color: isActive === "projects" ? " #EDD569" : "",
                  }}
                  className={
                    isActive === "projects" ? "Link_Style_Scroll" : "Link_Style"
                  }
                  onClick={() => {
                    // setIsActive("distribution");
                    scrolldiv("projects", 90);
                  }}
                  style={({ isActive }) => {
                    return {
                      backgroundImage: isActive
                        ? "background-color: #EDD569"
                        : "",
                      color: isActive ? "white" : "#266A86",
                      color: isScrolling ? "#171717" : "white",
                      border: "none",
                      borderRadius: "60px",
                    };
                  }}
                >
                  Projects
                </NavLink>
              </div>
            </div>
            <div onClick={handleGetInTouch} className="NavbarButtonContainer">
              Contact us
            </div>

            <div className="collapse_button_number">
              <div
                onClick={handleGetInTouch}
                className="NavbarButtonContainer small_screen "
              >
                Contact us
              </div>

              <div className={"NavLink_App_Smaller_Devices"}>
                {toggleMenu ? (
                  <div className="Toggle_Btn_CLose">
                    <FiX
                      style={{
                        color: isScrolling ? "#171717" : "white",
                      }}
                      size={30}
                      onClick={() => setToggleMenu(false)}
                    />
                  </div>
                ) : (
                  <div className="Toggle_Btn_Open">
                    <FiAlignRight
                      style={{
                        color: isScrolling ? "#171717" : "white",
                      }}
                      size={30}
                      onClick={() => setToggleMenu(true)}
                    />
                  </div>
                )}

                {toggleMenu ? (
                  <div className={"NavLink_App_Smaller_Overlay"}>
                    <div
                      className={"Navlink_App_Links_Wrapper_SmallScreen_links"}
                    >
                      <NavLink
                        to="#home"
                        onClick={() => {
                          // setIsActive("home");
                          scrolldiv("home", 0);
                        }}
                        activeStyle={{
                          color: isActive === "home" ? " #EDD569" : "",
                        }}
                        className={
                          isActive === "home"
                            ? "Link_Style_Scroll"
                            : "Link_Style"
                        }
                        style={({ isActive }) => {
                          return {
                            backgroundImage: isActive
                              ? "background-color: #EDD569"
                              : "",
                            color: isActive ? "266A86" : "",
                            border: "none",
                            borderRadius: "60px",
                          };
                        }}
                      >
                        Home
                      </NavLink>

                      <NavLink
                        to="#about_me"
                        activeStyle={{
                          color: isActive === "about_me" ? "#EDD569" : "",
                        }}
                        className={
                          isActive === "about_me"
                            ? "Link_Style_Scroll"
                            : "Link_Style"
                        }
                        onClick={() => {
                          // setIsActive("logistics");
                          if (
                            window.innerWidth > 768 &&
                            window.innerWidth < 1025
                          ) {
                            scrolldiv("about_me", 90);
                          } else {
                            scrolldiv("about_me", 70);
                          }
                        }}
                        style={({ isActive }) => {
                          return {
                            backgroundImage: isActive
                              ? "background-color: #EDD569"
                              : "",
                            color: isActive ? "266A86" : "black",
                            border: "none",
                            borderRadius: "60px",
                          };
                        }}
                      >
                        About Me
                      </NavLink>

                      <NavLink
                        to="/document_verification"
                        activeStyle={{
                          color: isActive === "aboutUs" ? " #EDD569" : "",
                        }}
                        className="Link_Style"
                        // className={
                        //   isActive === "about__Us"
                        //     ? "Link_Style_Scroll"
                        //     : "Link_Style"
                        // }
                        // onClick={() => {
                        //   setIsActive("about__Us");
                        //   if (
                        //     window.innerWidth > 768 &&
                        //     window.innerWidth < 1025
                        //   ) {
                        //     scrolldiv("about__Us", 90);
                        //   } else {
                        //     scrolldiv("about__Us", 70);
                        //   }
                        // }}
                        style={({ isActive }) => {
                          return {
                            backgroundImage: isActive
                              ? "background-color: #EDD569"
                              : "",
                            color: isActive ? "266A86" : "",
                            border: "none",
                            borderRadius: "60px",
                          };
                        }}
                      >
                        Document Verification
                      </NavLink>

                      <NavLink
                        to="#services"
                        activeStyle={{
                          color: isActive === "services" ? " #EDD569" : "",
                        }}
                        className={
                          isActive === "services"
                            ? "Link_Style_Scroll"
                            : "Link_Style"
                        }
                        onClick={() => {
                          // setIsActive("mission__vision");
                          if (
                            window.innerWidth > 768 &&
                            window.innerWidth < 1025
                          ) {
                            scrolldiv("services", 90);
                          } else {
                            scrolldiv("services", 70);
                          }
                        }}
                        style={({ isActive }) => {
                          return {
                            backgroundImage: isActive
                              ? "background-color: #EDD569"
                              : "",
                            color: isActive ? "266A86" : "",
                            border: "none",
                            borderRadius: "60px",
                          };
                        }}
                      >
                        Services
                      </NavLink>

                      <NavLink
                        to="#projects"
                        activeStyle={{
                          color: isActive === "projects" ? " #EDD569" : "",
                        }}
                        className={
                          isActive === "projects"
                            ? "Link_Style_Scroll"
                            : "Link_Style"
                        }
                        onClick={() => {
                          // setIsActive("distribution");
                          if (
                            window.innerWidth > 768 &&
                            window.innerWidth < 1025
                          ) {
                            scrolldiv("projects", 90);
                          } else {
                            scrolldiv("projects", 70);
                          }
                        }}
                        style={({ isActive }) => {
                          return {
                            backgroundImage: isActive
                              ? "background-color: #EDD569"
                              : "",
                            color: isActive ? "266A86" : "",
                            border: "none",
                            borderRadius: "60px",
                          };
                        }}
                      >
                        Projects
                      </NavLink>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </nav>
      </Fade>
    </>
  );
}
